import { render, staticRenderFns } from "./ProdutosForm.vue?vue&type=template&id=1acae816&scoped=true&"
import script from "./ProdutosForm.vue?vue&type=script&lang=js&"
export * from "./ProdutosForm.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosForm.vue?vue&type=style&index=0&id=1acae816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acae816",
  null
  
)

export default component.exports